import { render, staticRenderFns } from "./AnnouncementsStack.vue?vue&type=template&id=5ddab06c&scoped=true&"
import script from "./AnnouncementsStack.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsStack.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementsStack.vue?vue&type=style&index=0&id=5ddab06c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddab06c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
